import { Checkbox, Stack } from '@mantine/core';

interface CheckboxGroupProps {
  label?: string;
  items?: { id: string; label: string }[];
  value?: string[];
  onChange?: (selectedIds: string[]) => void;
  isDisabled?: boolean;
  isReadonly?: boolean;
  description?: string;
  name: string;
}

export const CheckboxGroup = ({
  label,
  items = [],
  value = [],
  onChange,
  isDisabled,
  isReadonly,
  description,
  name,
}: CheckboxGroupProps) => {
  return (
    <Checkbox.Group
      label={label}
      description={description}
      value={value}
      onChange={onChange}
    >
      <Stack gap="xs" mt="xs">
        {items.map((item) => (
          <Checkbox
            key={item.id}
            value={item.id}
            label={item.label}
            disabled={isDisabled || isReadonly}
          />
        ))}
      </Stack>
    </Checkbox.Group>
  );
};
